export const DESCRIPTION_MAX_LENGTH = 5000; // 5000 characters
